import {getSmsLoginError} from "../api/sms_login";
import {SmsCodeCooldownKind, startSmsCodeCooldown} from "./registration_wizard_sms_cooldown";

export const sendRegistrationWizardSmsCode = async (request: PromiseLike<{data?: unknown; error?: unknown}>, cooldownKind: SmsCodeCooldownKind) => {
    const response = await request;

    if (response.error) {
        return {error: getSmsLoginError(response.error, "Nie udało się wysłać kodu SMS."), cooldownStart: null};
    }

    return {error: null, cooldownStart: startSmsCodeCooldown(cooldownKind)};
};
import {getSmsLoginError} from "../api/sms_login";
import {SmsCodeCooldownKind, startSmsCodeCooldown} from "./registration_wizard_sms_cooldown";

export const sendRegistrationWizardSmsCode = async (request: PromiseLike<{data?: unknown; error?: unknown}>, cooldownKind: SmsCodeCooldownKind) => {
    const response = await request;

    if (response.error) {
        return {error: getSmsLoginError(response.error, "Nie udało się wysłać kodu SMS."), cooldownStart: null};
    }

    return {error: null, cooldownStart: startSmsCodeCooldown(cooldownKind)};
};
